import React from 'react'
import strings from '../../../lang/strings'

export default function AppTextarea(props) {
    return (
      <div className={props.className}>
        <div className={'position-relative'}>
          <textarea  id={props.id} value={props.value} className={'form-control form-control1 ' + (props.errorMsg !== '' ? 'error ' : '') + (props.readonly ? 'form-readonly' : '')} required={true} onChange={props.onChange} onKeyDown={props.onKeyDown}/>
          <label className='form-control-placeholder' htmlFor={props.id}>{props.placeholder}{props.required && <span className='text-danger'>*</span>}{props.maxLength && <span className='ml-16 fs-14'>{'/' + props.maxLength + strings.max_length}</span>}</label>
          <div className={'invalid-feedback ' + (props.errorMsg !== '' ? 'error' : '')}>{props.errorMsg}</div>
        </div>
      </div>
    )
}

